// extracted by mini-css-extract-plugin
module.exports = {"tags":"TagCloud_tags__vSC7_","tagsList":"TagCloud_tagsList__kFkyT"};